/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { callSpecificTicket, removeSpecificTicket, updateTicket } from '../index';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { APITicket } from '../../../types/ticket';
import styled from 'styled-components';
import { TicketItem } from './ticket-item';
import { Dispatch } from 'redux';
import { sizes } from '../../../themes/sizes';

const Container = styled.section`
  display: grid;
  gap: ${sizes.margins.normal};
`;

interface QueueTicketsProps {
  queueId: string;
  tickets: Array<APITicket>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  comments: Array<any>;
  onUpdateTicket: (ticket: APITicket) => void;
  onRemoveSpecificTicket: (queueId: string, ticketUUID: string) => void;
  onCallSpecificTicket: (queueId: string, ticketUUID: string) => void;
}

function $QueueTickets(props: QueueTicketsProps) {
  return (
    <Container>
      {props.tickets.map((t) => {
        const { comments } = props;
        const ticketComments = R.filter((c: any) => c.ticketUUID === t.uuid)(comments);
        return (
          <TicketItem
            comments={ticketComments}
            ticket={t}
            queueId={props.queueId}
            key={t.uuid}
            onUpdateTicket={props.onUpdateTicket}
            onCallSpecificTicket={props.onCallSpecificTicket}
            onRemoveSpecificTicket={props.onRemoveSpecificTicket}
          />
        );
      })}
    </Container>
  );
}

const mapStateToProps = () => ({ comments: [] });
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUpdateTicket: (ticket: APITicket) => {
    dispatch(updateTicket(ticket.queueId, ticket));
  },
  onCallSpecificTicket: (queueId: string, ticketUUID: string) => dispatch(callSpecificTicket(queueId, ticketUUID)),
  onRemoveSpecificTicket: (queueId: string, ticketUUID: string) => dispatch(removeSpecificTicket(queueId, ticketUUID))
});

export const QueueTickets = connect(mapStateToProps, mapDispatchToProps)($QueueTickets);
